<template>
  <div class="book-carousel">
    <div class="book-carousel-inner">
      <img
        :src="larrow"
        alt="arrow"
        class="arrow"
        @click="prev"
        @mouseenter="handleMouseEnterl"
        @mouseleave="handleMouseLeavel"
      />
      <el-carousel
        :autoplay="false"
        arrow="never"
        ref="carousel"
        indicator-position="none"
      >
        <el-carousel-item v-for="(item, index) in counter" :key="item">
          <div class="book-cards">
            <div
              v-for="book in bookToShow(index)"
              :key="book.id"
              class="book-card"
            >
              <img
                :src="book.image"
                data-warden-title="显示文章内容"
                :data-warden-info="book.name"
                :data-warden-bookId="book.bookId"
                alt="中医古籍"
                class="book-cover"
                @click="jumpToBook(book.bookId)"
              />
              <div class="book-title" data-warden-title="显示文章内容" @click="jumpToBook(book.bookId)" :title="book.name">
                {{ book.name }}
              </div>
            </div>
          </div>
        </el-carousel-item>
      </el-carousel>
      <img
        :src="rarrow"
        alt="arrow"
        class="arrow"
        @click="next"
        @mouseenter="handleMouseEnterr"
        @mouseleave="handleMouseLeaver"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: 'BookCarousel',
  props: {
    carouselData: {
      type: Array,
      required: true
    }
  },
  data () {
    return {
      larrow: require('@/assets/images/leftarrow.png'),
      rarrow: require('@/assets/images/rightarrow.png'),
      counter: []
    }
  },
  mounted () {
    for (let i = 0; i <= this.carouselData.length / 5; i++) {
      this.counter.push(i)
    }
  },
  methods: {
    prev () {
      this.$refs.carousel.prev()
    },
    next () {
      this.$refs.carousel.next()
    },
    handleMouseEnterl () {
      this.larrow = require('@/assets/images/leftarrowon.png')
    },
    handleMouseLeavel () {
      this.larrow = require('@/assets/images/leftarrow.png')
    },
    handleMouseEnterr () {
      this.rarrow = require('@/assets/images/rightarrowon.png')
    },
    handleMouseLeaver () {
      this.rarrow = require('@/assets/images/rightarrow.png')
    },
    bookToShow (page) {
      return this.carouselData.slice(page * 5, page * 5 + 5)
    },
    jumpToBook (id) {
      let pathInfo = '/bookDetail'
      if (this.$route.params.url) {
        pathInfo = '/' + this.$route.params.url + pathInfo
      }
      let routeUrl = this.$router.resolve({
        path: pathInfo,
        query: {
          book: id
        }
      })
      window.open(routeUrl.href, '_blank')
    },
    limitWord (word) {
      if (word.length > 7) {
        return word.slice(0, 7) + '...'
      } else {
        return word
      }
    }
  },
  watch: {
    carouselData () {
      this.counter = []
      for (let i = 0; i <= this.carouselData.length / 5; i++) {
        this.counter.push(i)
      }
    }
  }
}
</script>

<style scoped>
.book-carousel-inner {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
}

.book-carousel-inner >>> .el-carousel {
  width: 100%;
}

.book-carousel-inner >>> .el-carousel__container {
  height: 300px !important;
}

.arrow {
  width: 37px;
  height: 37px;
  margin: 0 10px;
  cursor: pointer;
  /* margin: 0 107px; */
}

.book-carousel-inner >>> .el-carousel {
  padding: 20px 10px;
}

.book-carousel-inner >>> .el-carousel__item {
  display: flex;
  justify-content: center;
  align-items: center;
}

.book-cards {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
}

.book-card {
  background-color: #fff;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  margin: 10px;
}

.book-cover {
  width: 120px;
  height: 170px;
  margin: 5px;
  cursor: pointer;
  transition: all 0.3s;
}

.book-cover:hover {
  transform: scale(1.05);
}

.book-title {
  margin-top: 10px;
  margin-bottom: 20px;
  font-size: 14px;
  color: #9e5c1d;
  cursor: pointer;
}

.book-title:hover {
  color: #9e5c1d;
}

.wrapper-image {
  height: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>



// WEBPACK FOOTER //
// src/components/BookCarouselContent.vue